export function truncateText(text, num) {
  const words = text.split(" ");
  let result = "";
  for (const word of words) {
    if (`${result}${word}`.length <= num) {
      result += ` ${word}`;
    } else {
      break;
    }
  }
  return result.trim();
}

export const decodeHtmlEntities = (text) => {
  if (!text || text.length < 5) return text;
  return text
    .replace(/&nbsp;/g, " ")
    .replace(/<!--more-->/g, "")
    .replace(/\n/g, " ")
    .replace(/&#8217;/g, "’")
    .replace(/&rsquo;/g, "’")
    .replace(/&lsquo;/g, "’")
    .replace(/&#8211;/g, "-")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&#8216;/g, "'")
    .replace(/&#8220;/g, '"')
    .replace(/&#8221;/g, '"')
    .replace(/&#8230;/g, "...")
    .replace(/&#8242;/g, "'")
    .replace(/&#8243;/g, '"')
    .replace(/&#8249;/g, "<")
    .replace(/&#8250;/g, ">")
    .replace(/&#8254;/g, "‾")
    .replace(/&#8260;/g, "/")
    .replace(/&#8364;/g, "€")
    .replace(/&#36;/g, "$")
    .replace(/&pound;/g, "£")
    .replace(/&#8369;/g, "₱") // Philippine Peso
    .replace(/&#8355;/g, "֏") // Armenian Dram
    .replace(/&#8373;/g, "₾") // Georgian Lari
    .replace(/&#8365;/g, "៛") // Cambodian Riel
    .replace(/&#165;/g, "¥")
    .replace(/&#8361;/g, "₩")
    .replace(/&#8377;/g, "₹")
    .replace(/&#8362;/g, "₲")
    .replace(/&#8372;/g, "₼") // Azerbaijani Manat
    .replace(/&#8368;/g, "₦") // Nigerian Naira
    .replace(/&#8370;/g, "₴") // Ukrainian Hryvnia
    .replace(/&#8363;/g, "₳") // Turkmen Manat
    .replace(/&#8359;/g, "₺") // Turkish Lira
    .replace(/&#8365;/g, "៛") // Cambodian Riel
    .replace(/&#67;&#36;/g, "C$") // Canadian Dollar;
    .replace(/&#8482;/g, "™")
    .replace(/&#169;/g, "©")
    .replace(/&#174;/g, "®")
    .replace(/&#8722;/g, "−")
    .replace(/&#8212;/g, "—")
    .replace(/&#8226;/g, "•")
    .replace(/&#8592;/g, "←")
    .replace(/&#8593;/g, "↑")
    .replace(/&#8594;/g, "→")
    .replace(/&#8595;/g, "↓")
    .replace(/&#8596;/g, "↔")
    .replace(/&#8629;/g, "↩")
    .replace(/&#8658;/g, "⇒")
    .replace(/&#8660;/g, "⇔")
    .replace(/&#8704;/g, "∀")
    .replace(/&#8706;/g, "∂")
    .replace(/&#8707;/g, "∃")
    .replace(/&#8709;/g, "∅")
    .replace(/&#8712;/g, "∈")
    .replace(/&#8713;/g, "∉")
    .replace(/&#8715;/g, "∋")
    .replace(/&#8719;/g, "∏")
    .replace(/&#8721;/g, "∑")
    .replace(/&#8722;/g, "−")
    .replace(/&#8727;/g, "∗")
    .replace(/&#8730;/g, "√")
    .replace(/&#8733;/g, "∝")
    .replace(/&#8734;/g, "∞")
    .replace(/&#8736;/g, "∠")
    .replace(/&#8741;/g, "∥")
    .replace(/&#8743;/g, "∧")
    .replace(/&#8744;/g, "∨")
    .replace(/&#8745;/g, "∩")
    .replace(/&#8746;/g, "∪")
    .replace(/&#8747;/g, "∫")
    .replace(/&#8756;/g, "∴")
    .replace(/&#8764;/g, "∼")
    .replace(/&#8773;/g, "≅")
    .replace(/&#8776;/g, "≈")
    .replace(/&#8800;/g, "≠")
    .replace(/&#8801;/g, "≡")
    .replace(/&#8804;/g, "≤")
    .replace(/&#8805;/g, "≥")
    .replace(/&#8834;/g, "⊂")
    .replace(/&#8835;/g, "⊃")
    .replace(/&#8836;/g, "⊄")
    .replace(/&#8838;/g, "⊆")
    .replace(/&#8839;/g, "⊇")
    .replace(/&#8853;/g, "⊕")
    .replace(/&#8855;/g, "⊗")
    .replace(/&#8869;/g, "⊥")
    .replace(/&#8901;/g, "⋅")
    .replace(/&#8968;/g, "⌈")
    .replace(/&#8969;/g, "⌉")
    .replace(/&#8970;/g, "⌊")
    .replace(/&#8971;/g, "⌋")
    .replace(/&#9001;/g, "〈")
    .replace(/&#9002;/g, "〉")
    .replace(/&#9674;/g, "◊")
    .replace(/&#9824;/g, "♠")
    .replace(/&#9827;/g, "♣")
    .replace(/&#9829;/g, "♥")
    .replace(/&#9830;/g, "♦");
};

export const formatAndLimit = (text, amount = 150) => {
  const textOnly = text?.length ? text?.replace(/<\/?p>/g, "") : "";
  const textDescription = textOnly
    ? decodeHtmlEntities(textOnly).substring(0, amount)
    : "";
  return truncateText(textDescription, amount) || "";
};

export const formatRedirectUrl = (url) => {
  if (typeof url !== "string") return url;

  // Remove protocol and everything up to and including the second slash
  const parts = url.split("//");
  const pathParts = parts[parts.length - 1].split("/");
  const formattedUrl = pathParts.slice(2).join("/");

  // Remove query parameters
  // const queryIndex = formattedUrl.indexOf("?");
  // if (queryIndex !== -1) {
  //   formattedUrl = formattedUrl.slice(0, queryIndex);
  // }

  // Remove trailing slash
  return formattedUrl.replace(/\/$/, "");
};

export function removeTrailingSlash(inputString) {
  if (inputString?.endsWith("/")) {
    return inputString?.slice(0, -1);
  }
  return inputString;
}

export const trailingSlashExist = (inputString) => {
  return inputString?.length ? inputString.endsWith("/") : false;
};
